import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import ScreenSize from '../../../constants/screen-sizes';

export const StyledGalleryContainer = styled(Flex)`
  height: calc(80vh - 16px);

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    height: calc(95vh - 16px);
  }
`;

export const StyledGalleryThumbnail = styled(Flex)`
  width: 228px;

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    display: none;
  }
`;

export const StyledGalleryOriginal = styled(Flex)`
  width: 100%;

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
  }
`;
